{
  "checkedInTitle": "チェックインが完了しました",
  "postCheckInInstructions": "チェックイン後のご案内",
  "appointmentDetails": "予約の詳細",
  "notifyWarehouse": "到着したことを倉庫に通知しました。倉庫側で受け入れ状況を確認します",
  "waitForStaff": "倉庫スタッフからの次の指示をお待ちください",
  "unplannedDescription": "予約がないようです。倉庫スタッフからの次の指示をお待ちください。",
  "whatsappDelay": "最初の WhatsApp メッセージが届くまで最大 1 分ほどかかる場合があります。",
  "bookNextTitle": "次回のご予約",
  "bookNextBody": "Opendock に登録すると、次回この施設を訪れる際に予約できます",
  "helpFooter": "サポートや追加情報が必要な場合は、倉庫スタッフにお問い合わせください",
  "finalize": "終了（{seconds}）"
}
